import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { InputImageWithProcessing } from 'common/components/fields/InputImageWithProcessing';
import { InputSwitch } from 'common/components/fields/InputSwitch';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import LoadingProgress from 'common/components/progress/loading';
import { cepMask, currencyMask } from 'helpers/masks';
import { FORM_RULES } from 'helpers/validations';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { ExpansionList, ExpansionPanel } from 'react-md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, FieldArray, Form, getFormValues, initialize, reduxForm, change } from 'redux-form'; // 1. change adicionado
import { getList as getCategoriesList } from '../../../categories/categoriesActions';
import {
  uploadVoucherCodes,
  getVoucherCodesCount,
  deleteUnusedVoucherCodes,
} from '../../../sales/productOrders/productOrdersActions'; // Ajuste o caminho se necessário
import * as XLSX from 'xlsx'; // 2. Biblioteca xlsx importada

const changeFieldValue = (form, value) => {
  return (dispatch) => {
    dispatch(initialize(form, value));
  };
};

const renderproducts = (props) => {
  function array_move(fromIndex, toIndex) {
    const element = props.formValues?.products[fromIndex];
    props.fields.splice(fromIndex, 1);
    props.fields.splice(toIndex, 0, element);
  }
  function goUp(index) {
    return array_move(index, index - 1);
  }
  function goDown(index) {
    return array_move(index, index + 1);
  }
  const atividade = props?.formValues;
  const now = new Date();
  const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);

  return (
    <>
      {props.fields.map((product, index) => (
        <Box
          key={index}
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          alignContent="center"
          style={{
            borderTop: '2px solid #E5E5E5',
            paddingTop: 5,
          }}>
          <Box display="flex" flexDirection="column" style={{ marginRight: 20, zIndex: 100 }}>
            {index !== 0 && props.fields.length > 1 ? (
              <ArrowDropUp style={{ cursor: 'pointer' }} onClick={() => goUp(index)} />
            ) : null}
            {index !== props.fields.length - 1 && props.fields.length > 1 ? (
              <ArrowDropDown style={{ cursor: 'pointer' }} onClick={() => goDown(index)} />
            ) : null}
          </Box>
          <ExpansionPanel
            key={index}
            footer={null}
            label={props.formValues?.products[index]?.name || `Produto ${index + 1}`}
            style={{
              marginBottom: 10,
              width: '100%',
              borderRadius: 4,
              boxShadow: 'none',
              backgroundColor: '#fff',
            }}>
            <MaterialGrid item xs={12}>
              <Box display="flex" justifyContent="space-between" style={{ marginBottom: 10 }}>
                <Typography
                  style={{
                    fontSize: 16,
                  }}>
                  Nome do produto
                </Typography>
                <Typography
                  style={{
                    cursor: 'pointer',
                    color: '#E34848',
                    fontSize: 16,
                  }}
                  onClick={() => (isDisabled ? null : props.fields.remove(index))}>
                  Excluir Produto
                </Typography>
              </Box>
              <Field
                component={InputLabelOutlined}
                label={`Nome do Produto ${index + 1}`}
                name={`${product}.name`}
                validate={[FORM_RULES.required]}
                required
                helperText="Indique o seu produto, marca e modelo. Evite usar condições de vendas."
                disabled={props.router.params.action === 'proposta' || isDisabled}
              />
            </MaterialGrid>
            <MaterialGrid container spacing={2} style={{ background: '#fff' }}>
              <Typography
                style={{
                  fontSize: 16,
                  display: 'block',
                  fontWeight: 500,
                  width: '100%',
                  margin: '10px 0',
                  paddingLeft: 10,
                }}>
                Imagem
              </Typography>

              <MaterialGrid item xs={12} style={{ maring: '15px 0' }}>
                <Field
                  squareOff
                  component={InputImageWithProcessing}
                  label={'Imagem .png ou .jpg'}
                  cols="12 12 12 12"
                  name={`${product}.image`}
                  aspect={16 / 9}
                  aspectLabel={'16:9'}
                  disabled={isDisabled}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12} sm={12}>
                <Field
                  component={InputLabelOutlined}
                  multiline
                  label={`Descrição do produto ${index + 1}`}
                  name={`${product}.description`}
                  validate={[
                    FORM_RULES.required,
                    FORM_RULES.max(
                      1000,
                      props.formValues.products[index]
                        ? props.formValues.products[index].description
                          ? props.formValues.products[index].description.length
                          : 0
                        : 0
                    ),
                  ]}
                  required
                  rows={3}
                  disabled={props.router.params.action === 'proposta' || isDisabled}
                  helperText={
                    props.formValues.products[index] && props.formValues.products[index].description
                      ? `Quantidade de caracteres: ${props.formValues.products[index].description.length}/1000`
                      : 'Indique o seu produto, marca e modelo. Evite usar condições de vendas.'
                  }
                />
              </MaterialGrid>
              <Typography
                style={{
                  fontSize: 16,
                  display: 'block',
                  fontWeight: 500,
                  width: '100%',
                  margin: '10px 0',
                  paddingLeft: 10,
                }}>
                Preços e estoque
              </Typography>
              <MaterialGrid item xs={4}>
                <Field
                  component={InputLabelOutlined}
                  label={`Preço cheio`}
                  name={`${product}.value`}
                  validate={[FORM_RULES.required, FORM_RULES.minValueProduct]}
                  required
                  disabled={props.router.params.action === 'proposta' || isDisabled}
                  {...currencyMask}
                />
              </MaterialGrid>
              <MaterialGrid item xs={4}>
                <Field
                  component={InputLabelOutlined}
                  label={`Desconto`}
                  name={`${product}.discount_value`}
                  validate={[FORM_RULES.required]}
                  required
                  disabled={props.router.params.action === 'proposta' || isDisabled}
                  {...currencyMask}
                />
              </MaterialGrid>
              <MaterialGrid
                item
                xs={4}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '0 8px 0 12px',
                }}>
                <Typography color="primary" style={{ fontSize: 12 }}>
                  Valor final
                </Typography>
                <Typography style={{ color: 'black', marginTop: 12 }}>
                  {props.formValues.products[index]
                    ? props.formValues.products[index].value === 0
                      ? 'Grátis'
                      : props.formValues.products[index].value &&
                        props.formValues.products[index].discount_value
                      ? props.formValues.products[index].value >=
                        props.formValues.products[index].discount_value
                        ? 'R$ ' +
                          (
                            parseFloat(props.formValues.products[index].value || 0) -
                            parseFloat(props.formValues.products[index].discount_value)
                          )
                            .toFixed(2)
                            .replace('.', ',')
                        : 'Desconto inválido'
                      : props.formValues.products[index].value
                      ? 'R$ ' +
                        parseFloat(props.formValues.products[index].value)
                          .toFixed(2)
                          .replace('.', ',')
                      : 'R$ 0,00'
                    : 'R$ 0,00'}
                </Typography>
              </MaterialGrid>
              <Typography
                style={{
                  fontSize: 16,
                  display: 'block',
                  fontWeight: 500,
                  width: '100%',
                  margin: '10px 0',
                  paddingLeft: 10,
                }}>
                Informações
              </Typography>
              <MaterialGrid item xs={6} sm={6}>
                <Field
                  component={InputLabelOutlined}
                  label={`Estoque total`}
                  name={`${product}.stock`}
                  validate={[FORM_RULES.required]}
                  required
                  type="number"
                  disabled={props.router.params.action === 'proposta' || isDisabled}
                />
              </MaterialGrid>
              <MaterialGrid item xs={6} sm={6}>
                <Field
                  component={InputLabelOutlined}
                  label={`Limite Por Usuário`}
                  name={`${product}.limit`}
                  validate={[FORM_RULES.required]}
                  required
                  type="number"
                  disabled={props.router.params.action === 'proposta' || isDisabled}
                />
              </MaterialGrid>
            </MaterialGrid>

            {/* 1. Adiciona o InputSwitch para controlar a importação por produto */}
            {props.formValues && props.formValues.sell_vouchers_code && (
              <div style={{ marginTop: 20, padding: '0 8px' }}>
                <Field
                  component={InputSwitch}
                  name={`${product}.has_voucher_import`}
                  label="Importar códigos de vouchers para este produto?"
                  disabled={isDisabled}
                />
              </div>
            )}

            {/* 2. Modifica a condição para exibir a caixa de upload */}
            {props.formValues &&
              props.formValues.sell_vouchers_code &&
              props.formValues.products[index]?.has_voucher_import && (
                <Box
                  style={{
                    width: '100%',
                    borderTop: '2px solid #E5E5E5',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 26,
                    marginTop: 20,
                  }}>
                  <Typography
                    style={{
                      fontFamily: 'Roboto',
                      fontStyle: 'normal',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      marginBottom: 8,
                    }}>
                    Importar Códigos de Vouchers
                  </Typography>

                  {/* Exibe a contagem de vouchers já importados */}
                  {props.voucherCounts &&
                    props.voucherCounts[props.formValues.products[index]?.id] && (
                      <Box
                        style={{
                          backgroundColor: '#e8f5e9',
                          borderRadius: 8,
                          padding: '12px 20px',
                          marginBottom: 16,
                          textAlign: 'center',
                        }}>
                        <Typography
                          style={{
                            fontFamily: 'Roboto',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            color: '#2e7d32',
                            marginBottom: 4,
                          }}>
                          Vouchers já importados
                        </Typography>
                        <Typography
                          style={{
                            fontFamily: 'Roboto',
                            fontSize: '13px',
                            color: '#1b5e20',
                          }}>
                          Total:{' '}
                          {props.voucherCounts[props.formValues.products[index]?.id]?.total || 0} |
                          Disponíveis:{' '}
                          {props.voucherCounts[props.formValues.products[index]?.id]?.available ||
                            0}{' '}
                          | Usados:{' '}
                          {props.voucherCounts[props.formValues.products[index]?.id]?.used || 0}
                        </Typography>
                        {(props.voucherCounts[props.formValues.products[index]?.id]?.available ||
                          0) > 0 && (
                          <Box
                            onClick={() => {
                              if (props.deletingIndex === index) return;
                              if (
                                window.confirm(
                                  'Tem certeza que deseja deletar todos os códigos não usados deste produto?'
                                )
                              ) {
                                props.handleDeleteUnusedCodes(
                                  index,
                                  props.formValues.products[index]?.id
                                );
                              }
                            }}
                            style={{
                              display: 'inline-block',
                              padding: '6px 12px',
                              backgroundColor: props.deletingIndex === index ? '#ccc' : '#f44336',
                              color: '#fff',
                              borderRadius: 4,
                              cursor: props.deletingIndex === index ? 'wait' : 'pointer',
                              fontSize: '12px',
                              marginTop: 8,
                            }}>
                            {props.deletingIndex === index
                              ? 'Deletando...'
                              : 'Deletar códigos não usados'}
                          </Box>
                        )}
                      </Box>
                    )}

                  {/* Mostra o arquivo selecionado ou a área de drop */}
                  {props.pendingFiles && props.pendingFiles[index] ? (
                    <Box
                      style={{
                        width: '100%',
                        border: '2px solid #4caf50',
                        borderRadius: 8,
                        padding: 20,
                        textAlign: 'center',
                        backgroundColor: '#e8f5e9',
                      }}>
                      <Box style={{ fontSize: 40, marginBottom: 10 }}>✅</Box>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          color: '#2e7d32',
                          marginBottom: 8,
                        }}>
                        Arquivo selecionado!
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize: '14px',
                          color: '#1b5e20',
                          marginBottom: 4,
                        }}>
                        📄 {props.pendingFiles[index].fileName}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize: '13px',
                          color: '#388e3c',
                          marginBottom: 12,
                        }}>
                        {props.pendingFiles[index].codesCount} códigos encontrados
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize: '12px',
                          color: '#666',
                          marginBottom: 12,
                        }}>
                        Os códigos serão enviados ao clicar no botão abaixo
                      </Typography>
                      <Box style={{ display: 'flex', gap: 10 }}>
                        <Box
                          onClick={() => props.handleRemoveFile(index)}
                          style={{
                            display: 'inline-block',
                            padding: '8px 16px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: '14px',
                          }}>
                          Remover arquivo
                        </Box>
                        <Box
                          onClick={() => {
                            const productId = props.formValues.products[index]?.id;
                            if (!productId) {
                              alert('Salve a atividade primeiro para obter o ID do produto.');
                              return;
                            }
                            if (props.uploadingIndex === index) {
                              return; // Evita clique duplo
                            }
                            props.handleUploadCodes(index, productId);
                          }}
                          style={{
                            display: 'inline-block',
                            padding: '8px 16px',
                            backgroundColor: props.uploadingIndex === index ? '#ccc' : '#4caf50',
                            color: '#fff',
                            borderRadius: 4,
                            cursor: props.uploadingIndex === index ? 'wait' : 'pointer',
                            fontSize: '14px',
                            opacity: !props.formValues.products[index]?.id ? 0.6 : 1,
                          }}>
                          {props.uploadingIndex === index ? 'Enviando...' : 'Enviar códigos'}
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      style={{
                        width: '100%',
                        border: '2px dashed #ccc',
                        borderRadius: 8,
                        padding: 30,
                        textAlign: 'center',
                        backgroundColor: '#fafafa',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.currentTarget.style.borderColor = '#5759FB';
                        e.currentTarget.style.backgroundColor = '#f0f0ff';
                      }}
                      onDragLeave={(e) => {
                        e.preventDefault();
                        e.currentTarget.style.borderColor = '#ccc';
                        e.currentTarget.style.backgroundColor = '#fafafa';
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.currentTarget.style.borderColor = '#ccc';
                        e.currentTarget.style.backgroundColor = '#fafafa';
                        props.handleFileSelect(e, index);
                      }}
                      onClick={() => document.getElementById(`file-upload-${index}`).click()}>
                      <Box style={{ fontSize: 40, color: '#5759FB', marginBottom: 10 }}>📁</Box>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          color: '#333',
                          marginBottom: 8,
                        }}>
                        Arraste o arquivo aqui
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Roboto',
                          fontSize: '14px',
                          color: '#6c757d',
                          marginBottom: 8,
                        }}>
                        ou clique para selecionar
                      </Typography>
                      <Typography style={{ fontFamily: 'Roboto', fontSize: '12px', color: '#999' }}>
                        Formatos aceitos: .csv, .xlsx, .xls
                      </Typography>
                    </Box>
                  )}
                  <input
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: 'none' }}
                    id={`file-upload-${index}`}
                    type="file"
                    onChange={(e) => props.handleFileSelect(e, index)}
                  />
                </Box>
              )}
          </ExpansionPanel>
        </Box>
      ))}
      <Box
        onClick={() => (isDisabled ? null : props.fields.push())}
        style={{
          width: '100%',
          borderTop: '2px solid #E5E5E5',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 26,
        }}>
        <Typography
          style={{
            color: '#5759FB',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
          }}>
          + Adicionar Produto
        </Typography>

        {/*
        <PrimaryButton
          disabled={
            props.disabled ||
            props.router.params.action === 'proposta' ||
            props.router.params.action === 'editar'
          }
        >
        </PrimaryButton> */}
      </Box>
    </>
  );
};

const renderQuestions = (props) => {
  function array_move(fromIndex, toIndex) {
    const element = props.formValues?.questions[fromIndex];
    props.fields.splice(fromIndex, 1);
    props.fields.splice(toIndex, 0, element);
  }
  function goUp(index) {
    return array_move(index, index - 1);
  }
  function goDown(index) {
    return array_move(index, index + 1);
  }
  const atividade = props?.formValues;
  const now = new Date();
  const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);

  return (
    <>
      {props.fields.map((question, index) => (
        <Box
          key={index}
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          alignContent="center"
          style={{
            borderTop: '2px solid #E5E5E5',
            paddingTop: 5,
          }}>
          <Box display="flex" flexDirection="column" style={{ marginRight: 20, zIndex: 100 }}>
            {index !== 0 && props.fields.length > 1 ? (
              <ArrowDropUp style={{ cursor: 'pointer' }} onClick={() => goUp(index)} />
            ) : null}
            {index !== props.fields.length - 1 && props.fields.length > 1 ? (
              <ArrowDropDown style={{ cursor: 'pointer' }} onClick={() => goDown(index)} />
            ) : null}
          </Box>
          <ExpansionPanel
            key={index}
            footer={null}
            label={props.formValues?.questions[index]?.name || `Pergunta ${index + 1}`}
            style={{
              marginBottom: 10,
              width: '100%',
              borderRadius: 4,
              boxShadow: 'none',
              backgroundColor: '#fff',
            }}>
            <MaterialGrid item xs={12}>
              <Box display="flex" justifyContent="space-between" style={{ marginBottom: 10 }}>
                <Typography
                  style={{
                    fontSize: 16,
                  }}>
                  Pergunta
                </Typography>
                <Typography
                  style={{
                    cursor: 'pointer',
                    color: '#E34848',
                    fontSize: 16,
                  }}
                  onClick={() => (isDisabled ? null : props.fields.remove(index))}>
                  Excluir Pergunta
                </Typography>
              </Box>
              <Field
                component={InputLabelOutlined}
                label={`Texto da pergunta ${index + 1}`}
                name={`${question}.question.text`}
                validate={[FORM_RULES.required]}
                required
                helperText={`Digite o texto da pergunta ${index + 1}`}
                disabled={isDisabled}
              />
            </MaterialGrid>
            <MaterialGrid item xs={12} sm={12}>
              <Field
                component={SelectLabel}
                type="text"
                label={`Tipo da Pergunta ${index + 1}`}
                name={`${question}.type`}
                margin="normal"
                defaultValue={{
                  value: 3,
                  label: 'Questão aberta',
                }}
                options={[
                  {
                    value: 3,
                    label: 'Questão aberta',
                  },
                ]}
                validate={[FORM_RULES.required]}
                disabled={Boolean(props.formValues?.questions[index]?.type) || isDisabled}
              />
            </MaterialGrid>
          </ExpansionPanel>
        </Box>
      ))}
      <Box
        onClick={() => (isDisabled ? null : props.fields.push())}
        style={{
          width: '100%',
          borderTop: '2px solid #E5E5E5',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 26,
        }}>
        <Typography
          style={{
            color: '#5759FB',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
          }}>
          + Adicionar Pergunta
        </Typography>
      </Box>
    </>
  );
};

const renderLocations = (props) => {
  const atividade = props?.formValues;
  const now = new Date();
  const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);
  return (
    <>
      {props.fields.map((location, index) => (
        <div
          key={index}
          style={{
            borderTop: '2px solid #E5E5E5',
          }}>
          <div
            key={index}
            style={{
              padding: 20,
              width: '100%',
              borderRadius: 4,
              boxShadow: 'none',
              backgroundColor: '#fff',
            }}>
            <span>Local {index + 1}</span>
            <MaterialGrid container spacing={3} style={{ backgroundColor: '#fff', marginTop: 10 }}>
              <MaterialGrid item xs={6} sm={6}>
                <Field
                  component={InputLabelOutlined}
                  label={`Nome do Local ${index + 1}`}
                  name={`${location}.name`}
                  validate={[FORM_RULES.required]}
                  required
                  disabled={
                    props.disabled ||
                    props.router.params.action === 'proposta' ||
                    props.router.params.action === 'editar' ||
                    isDisabled
                  }
                />
              </MaterialGrid>
              <MaterialGrid item xs={6} sm={6}>
                <Field
                  component={InputLabelOutlined}
                  label="Custo da entrega no local (R$)"
                  name={`${location}.price`}
                  type="tel"
                  disabled={
                    props.disabled ||
                    props.router.params.action === 'proposta' ||
                    props.router.params.action === 'editar' ||
                    isDisabled
                  }
                  validate={[FORM_RULES.required]}
                  required
                  {...currencyMask}
                />
              </MaterialGrid>

              <MaterialGrid item xs={12}>
                <Field
                  component={SelectLabel}
                  options={[
                    {
                      value: true,
                      label: 'Endereço do participante (entrega)',
                    },
                    { value: false, label: 'Meu endereço (retirada)' },
                  ]}
                  default
                  label="Tipo de local"
                  name={`${location}.delivery`}
                  disabled={
                    props.disabled || props.router.params.action === 'proposta' || isDisabled
                  }
                  validate={[FORM_RULES.required]}
                  required
                />
              </MaterialGrid>

              {props.formValues.delivery_locations[index] ? (
                !props.formValues.delivery_locations[index].delivery ? (
                  <>
                    <MaterialGrid item xs={12} sm={12}>
                      <Field
                        component={InputLabelOutlined}
                        label={`Logradouro do endereço de retirada`}
                        name={`${location}.street`}
                        validate={[FORM_RULES.required]}
                        required
                        disabled={
                          props.disabled || props.router.params.action === 'proposta' || isDisabled
                        }
                      />
                    </MaterialGrid>
                    <MaterialGrid item xs={12} sm={12}>
                      <Field
                        component={InputLabelOutlined}
                        label={`Número do endereço de retirada`}
                        name={`${location}.street_number`}
                        validate={[FORM_RULES.required]}
                        required
                        type={'number'}
                        disabled={
                          props.disabled || props.router.params.action === 'proposta' || isDisabled
                        }
                      />
                    </MaterialGrid>
                    <MaterialGrid item xs={12} sm={12}>
                      <Field
                        component={InputLabelOutlined}
                        label="CEP do endereço de retirada"
                        name={`${location}.zipcode`}
                        validate={[FORM_RULES.required]}
                        required
                        margin="normal"
                        {...cepMask}
                        disabled={
                          props.disabled || props.router.params.action === 'proposta' || isDisabled
                        }
                      />
                    </MaterialGrid>
                  </>
                ) : null
              ) : null}
            </MaterialGrid>
            <Box display="flex" justifyContent="start" width="100%">
              <SecondaryButton
                disabled={props.router.params.action === 'proposta' || isDisabled}
                onClick={() => props.fields.remove(index)}
                color="primary">
                Excluir Local
              </SecondaryButton>
            </Box>
          </div>
        </div>
      ))}
      {_.isEmpty(props.formValues.delivery_locations) && (
        <p style={{ textAlign: 'center', color: '#D0342C' }}>
          Adicione ao menos um endereço de entrega!
        </p>
      )}
      <Box
        onClick={() => (isDisabled ? null : props.fields.push())}
        style={{
          width: '100%',
          borderTop: '2px solid #E5E5E5',
          borderBottom: '2px solid #E5E5E5',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 26,
        }}>
        <Typography
          style={{
            color: '#5759FB',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
          }}>
          + Adicionar local de entrega/retirada
        </Typography>
      </Box>
    </>
  );
};

const Interaction = function (props) {
  // Estado para armazenar a contagem de vouchers por produto
  const [voucherCounts, setVoucherCounts] = useState({});
  // Estado para armazenar arquivos pendentes por índice do produto
  const [pendingFiles, setPendingFiles] = useState({});
  // Estado para controlar qual produto está enviando
  const [uploadingIndex, setUploadingIndex] = useState(null);
  // Estado para controlar qual produto está deletando códigos
  const [deletingIndex, setDeletingIndex] = useState(null);

  // Efeito para ativar has_voucher_import em todos os produtos quando sell_vouchers_code for ativado
  useEffect(() => {
    if (props.formValues?.sell_vouchers_code && props.formValues?.products?.length > 0) {
      props.formValues.products.forEach((product, index) => {
        if (!product?.has_voucher_import) {
          props.change('couponsForm', `products[${index}].has_voucher_import`, true);
        }
      });
    }
  }, [props.formValues?.sell_vouchers_code]);

  // Efeito para buscar a contagem de vouchers quando os produtos mudarem
  useEffect(() => {
    const fetchVoucherCounts = async () => {
      const products = props.formValues?.products || [];
      const productsWithId = products.filter((product) => product?.id);

      const promises = productsWithId.map((product) =>
        props
          .getVoucherCodesCount(product.id)
          .then((count) => ({ id: product.id, count }))
          .catch(() => ({ id: product.id, count: { total: 0, available: 0, used: 0 } }))
      );

      const results = await Promise.all(promises);
      const newCounts = {};
      results.forEach(({ id, count }) => {
        newCounts[id] = count;
      });

      setVoucherCounts(newCounts);
    };

    if (props.formValues?.sell_vouchers_code) {
      fetchVoucherCounts();
    }
  }, [props.formValues?.products, props.formValues?.sell_vouchers_code]);

  // Função para selecionar o arquivo (apenas armazena, não envia ainda)
  const handleFileSelect = (e, productIndex) => {
    const file = e.target.files?.[0] || e.dataTransfer?.files?.[0];
    if (!file) return;

    // Lê o arquivo e extrai os códigos
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const codes = data
          .slice(1)
          .map((row) => row[0])
          .filter((code) => code != null && code !== '')
          .map(String);

        if (codes.length === 0) {
          alert('Nenhum código válido foi encontrado no arquivo.');
          return;
        }

        // Valida que a quantidade de códigos é igual ao estoque do produto
        const stock = parseInt(props.formValues?.products?.[productIndex]?.stock, 10);
        if (isNaN(stock) || codes.length !== stock) {
          alert(
            `A quantidade de códigos no arquivo (${
              codes.length
            }) deve ser igual ao estoque do produto (${isNaN(stock) ? 'não definido' : stock}).`
          );
          return;
        }

        // Armazena o arquivo e os códigos no estado
        setPendingFiles((prev) => ({
          ...prev,
          [productIndex]: {
            file,
            fileName: file.name,
            codes,
            codesCount: codes.length,
          },
        }));
      } catch (error) {
        console.error('Erro ao processar o arquivo:', error);
        alert('Ocorreu um erro ao ler o arquivo. Verifique o formato.');
      }
    };
    reader.readAsBinaryString(file);
  };

  // Função para remover arquivo pendente
  const handleRemoveFile = (productIndex) => {
    setPendingFiles((prev) => {
      const newFiles = { ...prev };
      delete newFiles[productIndex];
      return newFiles;
    });
  };

  // Função para enviar os códigos imediatamente
  const handleUploadCodes = async (productIndex, productId) => {
    const actionId = props.formValues?.id;
    const fileData = pendingFiles[productIndex];

    if (!actionId || !productId || !fileData?.codes?.length) {
      alert('Erro: Produto deve ser salvo antes de enviar os códigos.');
      return;
    }

    // Valida novamente que a quantidade de códigos é igual ao estoque
    const stock = parseInt(props.formValues?.products?.[productIndex]?.stock, 10);
    if (isNaN(stock) || fileData.codes.length !== stock) {
      alert(
        `A quantidade de códigos (${fileData.codes.length}) deve ser igual ao estoque do produto (${
          isNaN(stock) ? 'não definido' : stock
        }).`
      );
      return;
    }

    setUploadingIndex(productIndex);

    const voucherData = {
      action_id: actionId,
      product_id: productId,
      codes: fileData.codes,
    };

    try {
      await props.uploadVoucherCodes(voucherData);

      // Remove o arquivo pendente após envio com sucesso
      setPendingFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[productIndex];
        return newFiles;
      });

      // Atualiza a contagem de vouchers para este produto
      try {
        const count = await props.getVoucherCodesCount(productId);
        setVoucherCounts((prev) => ({
          ...prev,
          [productId]: count,
        }));
      } catch (err) {
        console.error('Erro ao buscar contagem:', err);
      }
    } catch (err) {
      console.error('Erro ao enviar vouchers:', err);
    } finally {
      setUploadingIndex(null);
    }
  };

  // Função para deletar códigos não usados
  const handleDeleteUnusedCodes = async (productIndex, productId) => {
    if (!productId) {
      alert('Erro: Produto deve ser salvo antes de deletar os códigos.');
      return;
    }

    setDeletingIndex(productIndex);

    try {
      await props.deleteUnusedVoucherCodes(productId);

      // Atualiza a contagem de vouchers para este produto
      try {
        const count = await props.getVoucherCodesCount(productId);
        setVoucherCounts((prev) => ({
          ...prev,
          [productId]: count,
        }));
      } catch (err) {
        console.error('Erro ao buscar contagem:', err);
      }
    } catch (err) {
      console.error('Erro ao deletar vouchers:', err);
    } finally {
      setDeletingIndex(null);
    }
  };

  // Função para processar os arquivos pendentes após salvar
  const processPendingFiles = async (savedProducts) => {
    const actionId = props.formValues?.id;
    if (!actionId) return;

    const uploadPromises = Object.entries(pendingFiles)
      .filter(([productIndex, fileData]) => {
        const product = savedProducts[productIndex];
        return product?.id && fileData.codes.length > 0;
      })
      .map(([productIndex, fileData]) => {
        const product = savedProducts[productIndex];
        const voucherData = {
          action_id: actionId,
          product_id: product.id,
          codes: fileData.codes,
        };
        // A action agora retorna uma Promise diretamente
        return props.uploadVoucherCodes(voucherData).catch((err) => {
          console.error('Erro ao enviar vouchers:', err);
        });
      });

    await Promise.all(uploadPromises);
    // Limpa os arquivos pendentes após processar
    setPendingFiles({});
  };

  // 4. Função antiga mantida para compatibilidade (quando já tem ID)
  const handleFileUpload = (e, productId) => {
    const inputTarget = e.target;
    const actionId = props.formValues?.id;
  };

  function onSubmit(values) {
    if (!values.has_product_order_parameter) {
      values.product_order_parameter_title = null;
      values.product_order_parameter_subtitle = null;
    }
    values.categories = values.categories_field.map((item) => item.id);
    values.groupings = values.groupings_field.map((item) => item.id);
    values.submitFromButton = true;
    // Adiciona os arquivos pendentes aos valores para processar após salvar
    values.pendingVoucherFiles = pendingFiles;
    values.processPendingFiles = processPendingFiles;
    props.onClickProgress(values);
  }
  const atividade = props?.formValues;
  const now = new Date();
  const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);
  function renderSteps() {
    return (
      <>
        {props.formValues && props.formValues.type_id === 3 && (
          <div className="mb-3">
            <Field
              component={SelectLabel}
              type="text"
              label="Opções de resgate"
              name="payment_option"
              margin="normal"
              options={[
                { value: 'credit_and_payment', label: 'Créditos e pagamento' },
                { value: 'credit_only', label: 'Somente créditos' },
                { value: 'payment_only', label: 'Somente pagamento' },
              ]}
              validate={[FORM_RULES.required]}
              disabled={isDisabled}
            />
            <Field
              component={InputSwitch}
              name="allow_installments"
              label="Permite parcelamento?"
              disabled={isDisabled}
            />
            {props.formValues && props.formValues.allow_installments && (
              <Field
                style={{ marginTop: 12 }}
                component={InputLabelOutlined}
                label={`Quantidade de parcelas`}
                name={`max_installments`}
                validate={props.formValues.allow_installments ? [FORM_RULES.required] : null}
                required={props.formValues.allow_installments}
                type="number"
                disabled={isDisabled}
              />
            )}
            {props.formValues && props.formValues.allow_installments && (
              <Field
                style={{ marginTop: 12 }}
                component={InputLabelOutlined}
                label={`Número de parcelas isentas de juros`}
                name={`free_installments`}
                type="number"
                disabled={isDisabled}
              />
            )}
            <Field component={InputSwitch} name="sell_vouchers" label="Venda com vouchers" />
            <Field
              component={InputSwitch}
              name="sell_vouchers_code"
              label="Venda com vouchers e códigos próprio"
            />
            {props.formValues && props.formValues.sell_vouchers_code && (
              <Field
                style={{ marginTop: 12 }}
                component={InputLabelOutlined}
                label="Data de validade do voucher"
                name="date_validity_voucher"
                type="datetime-local"
                validate={[FORM_RULES.required]}
                required
                disabled={isDisabled}
                InputLabelProps={{ shrink: true }}
              />
            )}
          </div>
        )}
        <div className="mb-3">
          <Field
            component={InputSwitch}
            name="only_one_product"
            label="Nessa atividade, o participante poderá comprar apenas um produto"
            disabled={
              props.router.params.action === 'proposta' ||
              props.router.params.action === 'editar' ||
              isDisabled
            }
          />
        </div>
        {props.formValues && _.isEmpty(props.formValues.products) && (
          <p style={{ textAlign: 'center', color: '#D0342C' }}>
            Ainda não há produtos. Adicione alguns!
          </p>
        )}
        <ExpansionList>
          {/* 5. Passa as funções de arquivo como props */}
          <FieldArray
            name="products"
            component={renderproducts}
            {...props}
            handleFileSelect={handleFileSelect}
            handleRemoveFile={handleRemoveFile}
            handleUploadCodes={handleUploadCodes}
            handleDeleteUnusedCodes={handleDeleteUnusedCodes}
            pendingFiles={pendingFiles}
            voucherCounts={voucherCounts}
            uploadingIndex={uploadingIndex}
            deletingIndex={deletingIndex}
          />
        </ExpansionList>

        {props.formValues && _.isEmpty(props.formValues.questions) && (
          <p style={{ textAlign: 'center', color: '#D0342C' }}>
            Ainda não há perguntas. Adicione algumas!
          </p>
        )}
        <ExpansionList>
          <FieldArray name="questions" component={renderQuestions} {...props} />
        </ExpansionList>
        {props.formValues && !props.formValues.digital_product && (
          <>
            <ExpansionList>
              <FieldArray name="delivery_locations" component={renderLocations} {...props} />
            </ExpansionList>
          </>
        )}

        {props.formValues ? (
          props.formValues.has_product_order_parameter ? (
            <>
              <Field
                component={InputLabelOutlined}
                label="Título do Campo"
                name="product_order_parameter_title"
                validate={[FORM_RULES.required]}
                disabled={props.router.params.action === 'proposta' || isDisabled}
                required
                margin="normal"
              />
              <Field
                component={InputLabelOutlined}
                label="Subtítulo do Campo"
                name="product_order_parameter_subtitle"
                validate={[FORM_RULES.required]}
                disabled={props.router.params.action === 'proposta' || isDisabled}
                required
                margin="normal"
              />
            </>
          ) : null
        ) : null}

        {props.formValues && props.formValues.partner_id ? (
          <>
            <Typography style={{ margin: '15px 0' }} variant="subtitle2">
              Taxas
            </Typography>
            <Typography style={{ margin: '15px 0', fontSize: 12 }} variant="p">
              Quando o parceiro te enviar uma atividade de compra, ele pode oferecer uma porcentagem
              de suas vendas para você, por hospedar esses produtos na sua estação
            </Typography>
            <MaterialGrid container style={{ marginTop: 10 }}>
              <MaterialGrid xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  {props.formValues ? (
                    props.formValues.comission_owner_percentage ? (
                      <Typography>
                        Você receberá{' '}
                        <strong>{parseFloat(props.formValues.comission_owner_percentage)}% </strong>
                        da venda desses produtos.
                      </Typography>
                    ) : null
                  ) : null}
                </Box>
              </MaterialGrid>
            </MaterialGrid>
          </>
        ) : null}
        <GenericConfirmationCard
          open={props.openConfirmation}
          maxWidthFixed
          cancelClose={props.handleCancelClose}
          labelLeftButton={'Continuar aqui'}
          labelRightButton={props.buttonConfirmationLabel}
          general={props.general}
          title={props.confirmationTitle}
          text={props.confirmationSubtitle}
          confirmButtonColor={'primary'}
          onClose={() => props.setOpenConfirmation(false)}
          onClick={props.closeModal}
        />
      </>
    );
  }

  return props.coupons.loading && props.formValues.delivery_locations === undefined ? (
    <div className="d-flex justify-content-center mt-5">
      <LoadingProgress />
    </div>
  ) : (
    <>
      <Form role="form" onSubmit={props.handleSubmit(onSubmit)} noValidate>
        <div
          style={{
            overflowY: 'scroll',
            height: isMobile ? 'calc(100vh - 250px)' : 'calc(100vh - 355px)',
            overflowX: 'hidden',
            paddingRight: isMobile ? 0 : 15,
          }}>
          {renderSteps()}
        </div>
        <MaterialGrid
          container
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          style={{
            margin: '25px 0px',
            overflowX: 'hidden',
            paddingRight: isMobile ? 0 : 29,
          }}>
          <SecondaryButton
            type="button"
            color="secondary"
            onClick={props.prevClick}
            // progress={parseInt(this.props.general.submitProgress)}
            style={{
              margin: 0,
              width: '48%',
              padding: '10px 20px',
              textTransform: 'none',
            }}>
            Voltar
          </SecondaryButton>
          {props.formValues.digital_product === true ? (
            <PrimaryButton
              type="submit"
              color="primary"
              disabled={
                props.activeActions.buttonLoading ||
                props.formValues.products.length === 0 ||
                isDisabled
              }
              style={{
                margin: 0,
                width: '48%',
                padding: isMobile ? '12px 20px' : '10px 20px',
                textTransform: 'none',
                fontSize: isMobile ? 12 : undefined,
              }}>
              Salvar e continuar
            </PrimaryButton>
          ) : (
            <PrimaryButton
              type="submit"
              color="primary"
              disabled={
                props.activeActions.buttonLoading ||
                props.formValues.products.length === 0 ||
                props.formValues.delivery_locations.length === 0 ||
                isDisabled
              }
              style={{
                margin: 0,
                width: '48%',
                padding: isMobile ? '12px 20px' : '10px 20px',
                textTransform: 'none',
                fontSize: isMobile ? 12 : undefined,
              }}>
              Salvar e continuar
            </PrimaryButton>
          )}
        </MaterialGrid>
      </Form>
    </>
  );
};

Interaction.propTypes = {
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.any,
  }),
  buttonConfirmationLabel: PropTypes.any,
  closeModal: PropTypes.any,
  confirmationSubtitle: PropTypes.any,
  confirmationTitle: PropTypes.any,
  coupons: PropTypes.shape({
    loading: PropTypes.any,
  }),
  formValues: PropTypes.shape({
    comission_owner_percentage: PropTypes.any,
    delivery_locations: PropTypes.shape({
      length: PropTypes.number,
    }),
    digital_product: PropTypes.any,
    has_product_order_parameter: PropTypes.any,
    partner_id: PropTypes.any,
    products: PropTypes.shape({
      length: PropTypes.number,
    }),
    type_id: PropTypes.number,
  }),
  general: PropTypes.any,
  handleCancelClose: PropTypes.any,
  handleSubmit: PropTypes.func,
  onClickProgress: PropTypes.func,
  openConfirmation: PropTypes.any,
  prevClick: PropTypes.any,
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
    }),
  }),
  setOpenConfirmation: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    coupons: state.coupons,
    categories: state.categories,
    activeActions: state.activeActions,
    general: state.general,
    formValues: getFormValues('couponsForm')(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeFieldValue,
      getCategoriesList,
      change,
      uploadVoucherCodes,
      getVoucherCodesCount, // Action para buscar contagem de vouchers
      deleteUnusedVoucherCodes, // Action para deletar códigos não usados
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'couponsForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Interaction)
);
